"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var l = require("lenovo");
var general_dialog_1 = require("./general-dialog");
require("../sass/caps-style-overwrite.scss");
var translate = l.Translator.translate;
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.isMobile = function () {
        if (typeof window["isMobile"] != 'undefined')
            return window["isMobile"];
        return /(iPhone|iPod|Android|ios|iPad)/i.test(window.navigator.userAgent);
    };
    Utils.bodyElement = function (tag, className) {
        var root = document.getElementsByClassName(className)[0];
        if (root) {
            $(root).remove();
        }
        var div = document.createElement(tag);
        div.className = className;
        document.body.appendChild(div);
        root = document.getElementsByClassName(className)[0];
        return root;
    };
    Utils.loading = function (show) {
        var root = Utils.bodyElement("div", "dow-loading-place");
        if (show)
            ReactDOM.render(React.createElement(general_dialog_1.LoadingDialog, null), root);
        else
            ReactDOM.render(React.createElement("span", null), root);
    };
    Utils.showExpiredTips = function (onOk, onCancel) {
        if (onOk === void 0) { onOk = null; }
        if (onCancel === void 0) { onCancel = null; }
        var root = Utils.bodyElement("div", "dow-page-login-dialog");
        var config = {
            title: translate('Please Refresh The Page|Please Refresh The Page'),
            msg: translate('The Download Expired Tips|This Page Download Address Will Expired, Please Refresh The Page to Get the new download adress.'),
            yesBtn: translate('Refresh|Refresh'),
            callback: function (option) {
                if (option == "no") {
                    if (onCancel)
                        onCancel();
                }
                if (option == "yes") {
                    if (onOk)
                        onOk();
                }
            }
        };
        ReactDOM.render(React.createElement(general_dialog_1.GeneralDialog, __assign({}, config)), root);
    };
    Utils.showLoginTips = function (onOk, onCancel) {
        if (onOk === void 0) { onOk = null; }
        if (onCancel === void 0) { onCancel = null; }
        var root = Utils.bodyElement("div", "dow-page-login-dialog");
        var config = {
            title: translate('Please Sign in|Please Sign in'),
            msg: translate('you are not logged in|This operation requires account permissions, please login first'),
            yesBtn: translate('Sign in|Sign in'),
            callback: function (option) {
                if (option == "no") {
                    if (onCancel)
                        onCancel();
                }
                if (option == "yes") {
                    if (onOk)
                        onOk();
                }
            }
        };
        ReactDOM.render(React.createElement(general_dialog_1.GeneralDialog, __assign({}, config)), root);
    };
    Utils.showInwarriantySNCaps = function (loadingStart, loadingFinished) {
        if (loadingStart)
            loadingStart();
        l.LitePageLoader.loadCaps('PspInwarriantySNCaps', function () {
            if (loadingFinished)
                loadingFinished();
            $('#caps-search .icon-search').text(translate('Submit'));
        });
    };
    Utils.showPNCheckCaps = function (loadingStart, loadingFinished) {
        if (loadingStart)
            loadingStart();
        l.LitePageLoader.loadCaps('PNCheckCaps', function () {
            if (loadingFinished)
                loadingFinished();
            $('#caps-search .icon-search').text(translate('Submit'));
        });
    };
    Utils.driverListDateTime = function (dt) {
        if (l.CultureUtility.getCurrentLanguage() === "ja")
            return Utils.localDateTime2("yyyy年M月d日", dt);
        return Utils.localDateTime1("d M Y", dt);
    };
    Utils.localDateTime1 = function (format, dt) {
        var date = (typeof dt == 'number') ? new Date(dt) : dt;
        return format.replace(/(\\?)(.)/g, function (_, esc, chr) {
            return (esc === '' && DateFormat.replaceChars[chr])
                ? DateFormat.replaceChars[chr](date) : chr;
        });
    };
    Utils.localDateTime2 = function (format, dt) {
        var date = (typeof dt == 'number') ? new Date(dt) : dt;
        var o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            "S": date.getMilliseconds()
        };
        if (/(y+)/.test(format))
            format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(format))
                format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return format;
    };
    // Track
    Utils.satelliteTrack = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // @ts-ignore
        var _satellite = window._satellite;
        if (typeof _satellite !== 'undefined' &&
            _satellite != null &&
            typeof _satellite.track === 'function') {
            return _satellite.track.apply(null, args);
        }
        return null;
    };
    /**
     * Track for clicking the download icon.
     * @param fileType {string} The category Name.
     * @param fileName {string} The file URL.
     */
    Utils.fileDownloadTrack = function (_a) {
        var fileType = _a.fileType, fileName = _a.fileName;
        var lmd = window.lmd;
        if (typeof lmd === 'undefined') {
            // @ts-ignore
            lmd = window['lmd'] = {};
        }
        if (typeof lmd.event === 'undefined' ||
            typeof lmd.event.push !== 'function') {
            lmd.event = [];
        }
        lmd.file_type = fileType;
        lmd.file_name = fileName;
        Utils.satelliteTrack('files_download');
    };
    Utils.IsDownloadManagerSupportedUrl = function (url) {
        if (url) {
            var dIndex = url.indexOf("download.lenovo.com");
            return dIndex == 7 || dIndex == 8;
        }
        return false;
    };
    return Utils;
}());
exports.Utils = Utils;
var DateFormat = /** @class */ (function () {
    function DateFormat() {
    }
    DateFormat.shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    DateFormat.longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    DateFormat.shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    DateFormat.longDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // Defining patterns
    DateFormat.replaceChars = {
        // Day
        d: function (date) { var d = date.getDate(); return (d < 10 ? '0' : '') + d; },
        D: function (date) { return DateFormat.shortDays[date.getDay()]; },
        j: function (date) { return date.getDate(); },
        l: function (date) { return DateFormat.longDays[date.getDay()]; },
        N: function (date) { var N = date.getDay(); return (N == 0 ? 7 : N); },
        S: function (date) { var S = date.getDate(); return (S % 10 == 1 && S != 11 ? 'st' : (S % 10 == 2 && S != 12 ? 'nd' : (S % 10 == 3 && S != 13 ? 'rd' : 'th'))); },
        w: function (date) { return this.getDay(); },
        z: function (date) { var d = new Date(date.getFullYear(), 0, 1); return Math.ceil((date.getTime() - d.getTime()) / 86400000); },
        // Week
        W: function (date) {
            var target = new Date(date.valueOf());
            var dayNr = (date.getDay() + 6) % 7;
            target.setDate(target.getDate() - dayNr + 3);
            var firstThursday = target.valueOf();
            target.setMonth(0, 1);
            if (target.getDay() !== 4) {
                target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
            }
            var retVal = 1 + Math.ceil((firstThursday - target.getTime()) / 604800000);
            return (retVal < 10 ? '0' + retVal : retVal);
        },
        // Month
        F: function (date) { return DateFormat.longMonths[date.getMonth()]; },
        m: function (date) { var m = date.getMonth(); return (m < 9 ? '0' : '') + (m + 1); },
        M: function (date) { return DateFormat.shortMonths[date.getMonth()]; },
        n: function (date) { return date.getMonth() + 1; },
        t: function (date) {
            var year = date.getFullYear(), nextMonth = date.getMonth() + 1;
            if (nextMonth === 12) {
                year = year++;
                nextMonth = 0;
            }
            return new Date(year, nextMonth, 0).getDate();
        },
        // Year
        L: function (date) { var L = date.getFullYear(); return (L % 400 == 0 || (L % 100 != 0 && L % 4 == 0)); },
        o: function (date) { var d = new Date(date.valueOf()); d.setDate(d.getDate() - ((date.getDay() + 6) % 7) + 3); return d.getFullYear(); },
        Y: function (date) { return date.getFullYear(); },
        y: function (date) { return ('' + date.getFullYear()).substr(2); },
        // Time
        a: function (date) { return date.getHours() < 12 ? 'am' : 'pm'; },
        A: function (date) { return date.getHours() < 12 ? 'AM' : 'PM'; },
        B: function (date) { return Math.floor((((date.getUTCHours() + 1) % 24) + date.getUTCMinutes() / 60 + date.getUTCSeconds() / 3600) * 1000 / 24); },
        g: function (date) { return date.getHours() % 12 || 12; },
        G: function (date) { return date.getHours(); },
        h: function (date) { var h = date.getHours(); return ((h % 12 || 12) < 10 ? '0' : '') + (h % 12 || 12); },
        H: function (date) { var H = date.getHours(); return (H < 10 ? '0' : '') + H; },
        i: function (date) { var i = date.getMinutes(); return (i < 10 ? '0' : '') + i; },
        s: function (date) { var s = date.getSeconds(); return (s < 10 ? '0' : '') + s; },
        v: function (date) { var v = date.getMilliseconds(); return (v < 10 ? '00' : (v < 100 ? '0' : '')) + v; },
        // Timezone
        e: function (date) { return Intl.DateTimeFormat().resolvedOptions().timeZone; },
        I: function (date) {
            var DST = null;
            for (var i = 0; i < 12; ++i) {
                var d = new Date(date.getFullYear(), i, 1);
                var offset = d.getTimezoneOffset();
                if (DST === null)
                    DST = offset;
                else if (offset < DST) {
                    DST = offset;
                    break;
                }
                else if (offset > DST)
                    break;
            }
            return ((date.getTimezoneOffset() == DST) ? 1 : 0) | 0;
        },
        O: function (date) { var O = date.getTimezoneOffset(); return (-O < 0 ? '-' : '+') + (Math.abs(O / 60) < 10 ? '0' : '') + Math.floor(Math.abs(O / 60)) + (Math.abs(O % 60) == 0 ? '00' : ((Math.abs(O % 60) < 10 ? '0' : '')) + (Math.abs(O % 60))); },
        P: function (date) { var P = date.getTimezoneOffset(); return (-P < 0 ? '-' : '+') + (Math.abs(P / 60) < 10 ? '0' : '') + Math.floor(Math.abs(P / 60)) + ':' + (Math.abs(P % 60) == 0 ? '00' : ((Math.abs(P % 60) < 10 ? '0' : '')) + (Math.abs(P % 60))); },
        T: function (date) { var tz = date.toLocaleTimeString(navigator.language, { timeZoneName: 'short' }).split(' '); return tz[tz.length - 1]; },
        Z: function (date) { return -date.getTimezoneOffset() * 60; },
        // Full Date/Time
        r: function (date) { return date.toString(); },
        U: function (date) { return date.getTime() / 1000; }
    };
    return DateFormat;
}());
